import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import { Card } from '@material-tailwind/react';
import APDate from '../../../components/fields/APDate';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    /*   responsive: true,
      maintainAspectRatio : false, */
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: '(افغانی) عوايد -  مصارف',
        },
    },
};

//const labels = ['حوت','دلو','جدی','قوس','عقرب','ميزان', 'سنبله', 'اسد', 'سرطان', 'جوزا', 'ثور', 'حمل'];

const newLabels = [
    { v: 1, l: 'حمل' },
    { v: 2, l: 'ثور' },
    { v: 3, l: 'جوزا' },
    { v: 4, l: 'سرطان' },
    { v: 5, l: 'اسد' },
    { v: 6, l: 'سنبله' },
    { v: 7, l: 'ميزان' },
    { v: 8, l: 'عقرب' },
    { v: 9, l: 'قوس' },
    { v: 10, l: 'جدی' },
    { v: 11, l: 'دلو' },
    { v: 12, l: 'حوت' },
].reverse();

export const data = (v) => {
    return {
        labels: newLabels?.map(l => l.l),
        datasets: [
            {
                label: 'عوايد',
                data: newLabels?.map((m, i) => {
                    const kk = v?.data?.incomes;
                    let mm = 0
                    Object.keys(kk).map((n, j) => {
                        if (Number(n) === m?.v) {
                            kk[n].forEach(el => {
                                mm += Number(el?.amount);
                            });
                        }
                    })
                    return mm
                }),
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
            {
                label: 'مصارف',
                data: newLabels?.map((m, i) => {
                    const kk = v?.data?.expenses;
                    let mm = 0
                    Object.keys(kk).map((n, j) => {
                        if (Number(n) === m?.v) {
                            kk[n].forEach(el => {
                                mm += Number(el?.amount);
                            });
                        }
                    })
                    return mm
                }),
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },

        ],
    };
}

export function BarChart({ v }) {
  
    return <Card className={`bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 mb-5 ${v.className}`}>
        <div className=" flex flex-row-reverse">
            <APDate v={{ register:v.register, errors:v?.errors, control:v?.control, setValue:v?.setValue, data: { label: '', name: 'year_date', type: 'pdate', onlyYear: true, render: true } }} />
        </div>
        <Bar options={options} data={data(v)} />
    </Card>

}
